import Vue from 'vue'

export default function handleError(err) {
  const msg = err.message || '发生未知错误'
  Vue.prototype.$toast.error(msg)
}



// WEBPACK FOOTER //
// ./src/utils/handle-error.js